import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBolt } from '@fortawesome/pro-solid-svg-icons/faBolt';
import { faTimes } from '@fortawesome/pro-solid-svg-icons/faTimes';

import React from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';
import { useOnToggleQuickship } from '../../hooks/use-user-setting';

import style from './quickship-grid-treatment.module.less';

const message = defineMessages({
  QuickshipGridTreatment: {
    description: 'Quickship Grid Treatment Text',
    defaultMessage: 'QuickShip Mode enabled',
    id: 'hjKdJp',
  },
});

const QUICKSHIP_FROM_ORDERS_GRID_PATH = '/orders';
const QUICKSHIP_FROM_BATCHES_GRID_PATH = '/shipments/batches/open';

const QuickshipGridTreatment = () => {
  const onClick = useOnToggleQuickship();
  const pendoTrackingPrefix = window.location.pathname.includes(QUICKSHIP_FROM_BATCHES_GRID_PATH)
    ? QUICKSHIP_FROM_BATCHES_GRID_PATH
    : QUICKSHIP_FROM_ORDERS_GRID_PATH;
  return (
    <div className={style['quickship-bar']}>
      <div className={style.content}>
        <FontAwesomeIcon className={style['bolt-icon']} icon={faBolt} />
        <FormattedMessage {...message.QuickshipGridTreatment} />
        <div data-pendo-id={`${pendoTrackingPrefix}#quickship-grid-header-disable`} onClick={onClick}>
          <FontAwesomeIcon className={style['close-icon']} icon={faTimes} />
        </div>
      </div>
    </div>
  );
};

export default QuickshipGridTreatment;
